const Banner = () => {
    return (
        <div className={'booking-top'}>
            <div className="booking-banner">
                <div className="row booking-banner_top">
                    <div className="container hide_small">
                        <div className="col col-12">
                            <a href="/" className="booking-banner_top_service-logo">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </a>
                            <a href="https://www.mechanum.com/" className="booking-banner_top_step-back"><i
                                className="fas fa-arrow-left" aria-hidden="true">&nbsp;</i> Tillbaka till huvudsidan</a>
                            <ul>
                                <li>
                                    Ring oss: <a href={"tel:0105168000"}>010-516 80 00</a>
                                </li>
                                <li>
                                Maila oss: <a href="mailto:info@mechanum.com">info@mechanum.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="container soft-hidden show_small">
                        <div className="col col-12">


                            <div className={"banner_contact"}>
                                <li>
                                    <a href="/" className="booking-banner_top_service-logo">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </a>
                                </li>
                                <li>
                                    <a href={"tel:0105168000"}>010-516 80 00</a>
                                </li>
                                <li>
                                    <a href="mailto:info@mechanum.com">info@mechanum.com</a>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};
export default Banner
